import { writable } from 'svelte/store';
import type { LottieUID } from '../types';
import { triggeredUIDs } from './triggered-UIDs';

export const iconDOTriggers = createLottieTriggers(['loop', 'endLoop', 'oneTime', 'appear']);
export const textDOTriggers = createLottieTriggers(['appear']);

type Triggers<T extends string> = { [K in T]: number };
type TriggersFunction<T extends string> = { [K in `${T}Trigger`]: (uid: LottieUID) => void };

function createLottieTriggers<Animation extends string>(animations: Animation[]) {
  const triggers = animationsToTriggers(animations);

  const { subscribe, update } = writable(triggers);

  return {
    subscribe,
    ...animationsToTriggerFunctions(animations),
  };

  function animationsToTriggers<AnimationName extends Animation>(arr: AnimationName[]) {
    const obj = {} as Triggers<AnimationName>;
    for (const key of arr) {
      obj[key] = 0;
    }
    return obj;
  }

  function animationsToTriggerFunctions<AnimationName extends Animation>(arr: AnimationName[]) {
    const obj = {} as TriggersFunction<AnimationName>;
    for (const name of arr) {
      obj[`${name}Trigger`] = (uid: LottieUID) => {
        update((triggers) => ({ ...triggers, [name]: ++triggers[name] }));
        triggeredUIDs.add(uid, name);
      };
    }
    return obj;
  }
}
